const StateView = ({ state }: { state: any }) => {
  return (
    <div data-testid='state-view'>
      <pre>{JSON.stringify(state, undefined, 2)}</pre>
    </div>
  );
};

export default StateView;
